<template>

    <div class="uploader">
        <div class="uploader-body" :style="style">
            <a v-if="!loading && image" class="uploader-remove" href="#" @click.prevent="removePhoto">&times;</a>
            <input id="file" type="file" name="file" @change="uploadPhoto" />
            <div v-if="loading || !image" class="uploader-loader" :class="{ loading: loading }">
                <v-loader v-if="loading" size="lg" />
                <span v-else>Upload Image</span>
            </div>
            <div class="image" v-if="image" :style="{ 'background-image': `url(${image})` }"></div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .uploader {

        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        display: inline-block;
        padding: 5px;
        transition: border-color .3s;
        &:hover {
            border-color: $color-text;
        }

        .uploader-loader {
            align-items: center;
            background: $color-bg;
            display: flex;
            height: 100%;
            justify-content: center;
            position: absolute;
            width: 100%;
            z-index: 1;
            &.loading {
                background: rgba(255,255,255,0.9);
            }
            span {
                @include font-medium(13px);
            }
        }

        .uploader-remove {
            @include font-medium(16px);
            background: rgba(0,0,0,0.3);
            border-radius: 3px;
            color: #fff;
            height: 24px;
            margin: 0;
            position: absolute;
            right: 0;
            text-align: center;
            text-decoration: none;
            top: 0;
            transition: background-color .3s, color .3s;
            width: 24px;
            z-index: 3;
            &:hover {
                background: rgba(0,0,0,0.5);
            }
        }

        .uploader-body {
            overflow: hidden;
            position: relative;
            input[type=file] {
                background: transparent;
                cursor: pointer;
                height: 100%;
                left: 0;
                margin: 0;
                opacity: 0;
                padding: 0;
                position: absolute;
                top: 0;
                width: 100%;
                z-index: 2;
            }
            .image {
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                border-radius: 3px;
                height: 100%;
                width: 100%;
            }
        }

    }

</style>

<script>

import BaseApi from '@api/BaseApi';

export default {

    props: {
        uploaderWidth: {
            type: Number,
            default: 250,
        },
        uploaderHeight: {
            type: Number,
            default: 250,
        },
        uploaderImage: {
            type: String,
        },
        uploaderUrl: {
            type: String,
        },
    },

    data() {
        return {
            loading: false,
            image: this.uploaderImage,
            style: {
                'height': this.uploaderHeight + 'px',
                'width': this.uploaderWidth + 'px',
            },
        }
    },

    methods: {

        selectUpload(e) {
            document.getElementById('file').click();
        },

        uploadPhoto() {
            let file = document.getElementById('file').files[0];
            if (file) {
                this.loading = true;
                let params = new FormData();
                params.append('file', file);
                BaseApi.post(this.uploaderUrl, params)
                    .then((response) => {
                        this.loading = false;
                        this.image = response.data.data.link;
                    }, (error) => {
                        this.loading = false;
                        this.$store.commit('setAlertWithError', error);
                    });
            }
        },

        removePhoto() {
            this.loading = true;
            this.error = null;
            BaseApi.delete(this.uploaderUrl)
                .then((response) => {
                    this.loading = false;
                    this.image = null;
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    }

}

</script>
